export function bigintMax(
  value: bigint,
  ...values: ReadonlyArray<bigint>
): bigint;
export function bigintMax(...values: ReadonlyArray<bigint>): bigint | undefined;
export function bigintMax(
  ...values: ReadonlyArray<bigint>
): bigint | undefined {
  if (values.length === 0) {
    return undefined;
  } else {
    return values.reduce((currentMax, value) =>
      value > currentMax ? value : currentMax,
    );
  }
}

export function bigintMin(
  value: bigint,
  ...values: ReadonlyArray<bigint>
): bigint;
export function bigintMin(...values: ReadonlyArray<bigint>): bigint | undefined;
export function bigintMin(
  ...values: ReadonlyArray<bigint>
): bigint | undefined {
  if (values.length === 0) {
    return undefined;
  } else {
    return values.reduce((currentMin, value) =>
      value < currentMin ? value : currentMin,
    );
  }
}

export function bigintClamp(
  value: bigint,
  lowerBound: bigint,
  upperBound: bigint,
): bigint {
  return bigintMin(bigintMax(value, lowerBound), upperBound);
}

export function bigintRange(
  ...params: [stop: bigint] | [start: bigint, stop: bigint, step?: bigint]
): Array<bigint> {
  let start;
  let stop;
  let step;
  if (params.length === 1) {
    start = 0n;
    stop = params[0];
    step = 1n;
  } else {
    start = params[0];
    stop = params[1];
    step = params[2] ?? 1n;
  }

  const range = new Array<bigint>();

  for (let i = start; i < stop; i += step) {
    range.push(i);
  }

  return range;
}

export function compareBigInts(a: bigint, b: bigint): number {
  if (a < b) {
    return -1;
  } else if (a > b) {
    return 1;
  } else {
    return 0;
  }
}

export function parseBigInt(input: unknown): bigint | null {
  if (typeof input !== "string") {
    return null;
  } else {
    try {
      return BigInt(input);
    } catch {
      return null;
    }
  }
}
